{
  "title": "Disintegrate",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a lodestone and a pinch of dust)",
  "duration": "Instantaneous",
  "description": [
    "A thin green ray springs from your pointing finger to a target that you can see within range. The target can be a creature, an object, or a creation of magical force, such as the wall created by wall of force.",
    "A creature targeted by this spell must make a Dexterity saving throw. On a failed save, the target takes 10d6 + 40 force damage. The target is disintegrated if this damage leaves it with 0 hit points.",
    "A disintegrated creature and everything it is wearing and carrying, except magic items, are reduced to a pile of fine gray dust. The creature can be restored to life only by means of a true resurrection or a wish spell.",
    "This spell automatically disintegrates a Large or smaller nonmagical object or a creation of magical force. If the target is a Huge or larger object or creation of force, this spell disintegrates a 10-foot-cube portion of it. A magic item is unaffected by this spell.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, the damage increases by 3d6 for each slot level above 6th."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
